import { useCallback, useSyncExternalStore } from 'react';
import { useStableCallback } from './useStableCallback.js';
/**
 * Creates a form Field JSX component to handle optimistic updates and sync client form state to server.
 *
 * @param root0 Factory dependencies
 * @param root0.store Form store instance
 * @returns form Field JSX component
 */
export function createField({
  store
}) {
  return function Field({
    children,
    name,
    assert
  }) {
    const stableAssert = useStableCallback(assert);
    // TODO: prevent rerender in components that isn't subscribing to the particular slice thats changed
    const formStore = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getServerSnapshot);
    const fieldValue = formStore.fields[name];
    // No enums involved here; the rule false-positives on generic mapped types such as Store['meta'].
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-assignment
    const fieldMeta = formStore.meta[name];
    const handleChange = useCallback(arg => {
      if (!(stableAssert(arg) ?? true)) {
        return;
      }
      const fieldSnapshot = store.getSnapshot().fields;
      store.updateStore({
        fields: {
          ...fieldSnapshot,
          [name]: arg
        }
      });
    }, [stableAssert, name]);
    if (typeof children === 'function') {
      return children({
        state: fieldValue,
        meta: fieldMeta,
        handleChange
      });
    }
    return children;
  };
}